import RouteRegister from "@/plugins/router/services/RouteRegister"
import routers from '@/modules/wishlist/routers'
import plugin from "./plugins/index"
import StoreRegister from "@/plugins/store/services/StoreRegister"
import stores from "./stores"

export default {
    install: (app) => {
        StoreRegister.handle("wishlist", stores)
        RouteRegister.handle(routers)

        app.use(plugin);
    }
}
